import React from 'react';

import { createClassName } from 'utils/createClassName';

import './dashboardContentFallbackLayoutStyles.scss';

type Props = {
  title: React.ReactNode;
  description: React.ReactNode;
  action: React.ReactNode;
};

export const DashboardContentFallbackLayoutComponent = (props: Props) => {
  const { title, description, action } = props;

  const createDashboardContentFallbackLayoutClassName = createClassName(
    'dashboardContentFallbackLayout'
  );

  const wrapperClassName = createDashboardContentFallbackLayoutClassName(
    'wrapper'
  );

  const contentClassName = createDashboardContentFallbackLayoutClassName(
    'content'
  );

  const titleClassName = createDashboardContentFallbackLayoutClassName('title');

  const descriptionControlsClassName = createDashboardContentFallbackLayoutClassName(
    'description'
  );

  const actionControlsClassName = createDashboardContentFallbackLayoutClassName(
    'action'
  );

  return (
    <div className={wrapperClassName}>
      <div className={contentClassName}>
        <div className={titleClassName}>{title}</div>
        <div className={descriptionControlsClassName}>{description}</div>
        <div className={actionControlsClassName}>{action}</div>
      </div>
    </div>
  );
};
